import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Inline-only markdown for chat bubbles: bold/italic/strike/code, autolinked
// URLs, line breaks. No raw HTML (react-markdown is XSS-safe by default), and
// block elements are flattened so a bubble never renders headings/lists oddly.
const COMPONENTS = {
  a: ({ node, children, ...props }) => (
    <a {...props} target="_blank" rel="noopener noreferrer">{children}</a>
  ),
  // Keep paragraphs inline-ish so multi-line messages stay tight.
  p: ({ node, children, ...props }) => <span className="chat-text-p" {...props}>{children}</span>,
};

export default function ChatText({ children }) {
  return (
    <div className="chat-text">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        allowedElements={["p", "a", "strong", "em", "del", "code", "br"]}
        unwrapDisallowed
        components={COMPONENTS}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
